import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

// IMPORT PACKAGE REFERENCES

import { searchDevices } from '../State/Actions/DeviceActions';
import { FilterType } from './FilterType';
import { SortType } from './SortType';
import { DirectionType } from './DirectionType';


// COMPONENT

class DeviceFilter extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            searchText: '',
            sortType: SortType.ALPHABETICALLY,
        };

        this.handleSearch = this.handleSearch.bind(this);
    }


    handleSearch(event) {
        this.setState({searchText: event.target.value});
        this.props.searchDevices(event.target.value);
    }

    render() {
        return (
            <div className="filter-toolbar">
                <table className="full-width">
                    <tbody>
                        <tr>
                            <td>
                                <input value={this.state.searchText} onChange={this.handleSearch} type="text" className="form-control searchbar" placeholder="Search devices..."  />
                            </td>
                            <td className="right-detail">
                                <button type="button" className="btn btn-info" data-toggle="modal" data-target="#addDeviceModal">New Device</button>
                            </td>
                        </tr>
                    </tbody>
             </table>
          </div>
        )
    }
}


// CONFIGURE REACT REDUX
const mapStateToProps = state => {
  const { activeFilter } = state.pharmaciesReducer;
  return { activeFilter };
};

const mapDispatchToProps = dispatch => (
  bindActionCreators({ searchDevices }, dispatch)
);

const hoc = connect(mapStateToProps, mapDispatchToProps)(DeviceFilter);


// EXPORT COMPONENT

export { hoc as DeviceFilter };